import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const SmartEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 24px;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ImageWrapper = styled.div`
  position: relative;
  & > :first-child {
    border-bottom: none;
  }
`

export const Divider = styled.div`
  flex-shrink: 0;
  height: 1px;
  background: linear-gradient(
    270deg,
    transparent 0%,
    ${COLORS.border} 50%,
    transparent 100%
  );
`
